import { createContext } from 'react';
import type { EditMarketContextType } from './EditMarket.type.ts';

export const EditMarketContext = createContext<EditMarketContextType | null>(null);
